(function ($){
    class w4d_kupon{
        constructor(){
            this.theSelektor();
            this.theEvent();
            this.EventListeners();
        }
        theSelektor(){
            this.$body = $('body');
            this.woocommerce = $('.woo-wrapper');
            this.cart = $('.cart');
            this.add_coupon='.add_coupon';            
            this.remove_coupon='.remove_coupon';
            this.cartCollaterals = $('.cart-collaterals');
        }

        theEvent(){
            $(document).on('click', this.add_coupon, (e) => this.dodajKupon($(e.currentTarget)));
            $(document).on('click', this.remove_coupon, (e) => this.ukloniKupon($(e.currentTarget)));
        }  
        EventListeners() {
            $(document).on('keydown', '#coupon_code', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.dodajKupon(); // poziv metode iz ove klase
                }
            });
        }  
         

dodajKupon(){
    var couponCode = $("#coupon_code").val(); 
    
    $.ajax({
        url: wc_add_to_cart_params.ajax_url,
        type: "POST",
        data: {
            action: "dodaj_promokod",
            coupon_code: couponCode,
            beforeSend: () => {
                this.cart.addClass('cart--loading');
                this.cartCollaterals.addClass('cart-collaterals--loading');
            }
        },

        success: response => {                                                              
            if (response.success) {     
                let message=response.data.message.replace(/<[^>]*>?/gm, '');     

                W4D_FrontendHelper.showNotice('success', message);
                $('.cart-collaterals').html(response.data.cart_summary);                                       
            } else {
                $('#coupon-message').html('');
                if (response.data.tip==='1'){

                    $('#coupon-message').html(response.data.message); 

                }
                else
                {
                    
                    let message=response.data.message.replace(/<[^>]*>?/gm, '');   
                    W4D_FrontendHelper.showNotice('error', message);
                }
                
                //
            }
        },
        complete: () => {
            setTimeout(() => {
                this.cart.removeClass('cart--loading');
                this.cartCollaterals.removeClass('cart-collaterals--loading');
            }, 150);
        },
        error: (xhr, status, error) => {
        }
    });    
    }

    ukloniKupon(){
        let couponCode = $('.remove_coupon').data('coupon');
        

    $.ajax({
        url: wc_add_to_cart_params.ajax_url,
        type: "POST",
        data: {
            action: "ukloniKupon",
            coupon_code: couponCode,
            beforeSend: () => {
                this.cart.addClass('cart--loading');
                this.cartCollaterals.addClass('cart-collaterals--loading');
            }
        },

        success: response => {                                                              
            if (response.success) { 
                W4D_FrontendHelper.showNotice('success', response.data.message);
                $('.cart-collaterals').html(response.data.cart_summary);  
             }
             else
             {
                $('#coupon-message').html(response.data); 
             }                
              
            },
        
        complete: () => {
            setTimeout(() => {
                this.cart.removeClass('cart--loading');
                this.cartCollaterals.removeClass('cart-collaterals--loading');
            }, 150);
        },
        error: (xhr, status, error) => {
        }
    
}
)}



    


}

$(document).ready(() => {
    window.W4D_ = new w4d_kupon();
});
})(jQuery);